var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
let AlertScope = class AlertScope extends Scope {
    constructor() {
        super(...arguments);
        this.severity = 'info';
        this.title = '';
        this.message = '';
        this.onClose = Scope.ASYNC_ACTION;
        /** Chamado so quando ha `confirmText`. Sem ele, nada acontece. */
        this.onConfirm = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", String)
], AlertScope.prototype, "severity", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], AlertScope.prototype, "title", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], AlertScope.prototype, "message", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], AlertScope.prototype, "confirmText", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], AlertScope.prototype, "cancelText", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], AlertScope.prototype, "icon", void 0);
AlertScope = __decorate([
    Observable
], AlertScope);
export { AlertScope };
/**
 * A casca: o que esta no corpo, o que esta em cima dele, e quem esta logado.
 *
 * Nao ha campo para "que tela e esta". O corpo e um slot, e quem o preenche e o
 * presenter que estiver vivo - o shell nao conhece nenhum modulo, que e o que
 * permite portar as telas uma a uma sem tocar aqui.
 */
let MainScope = class MainScope extends Scope {
    constructor() {
        super(...arguments);
        this.initialized = false;
        this.signedIn = false;
        /**
         * A aparencia do painel - quem a aplica a pagina e o renderizador.
         *
         * Praia sem sessao: a tela de entrada e de todos. Ver `domain/panel-theme.ts`.
         */
        this.theme = 'PRAIA';
        this.onSignOut = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], MainScope.prototype, "initialized", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MainScope.prototype, "signedIn", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], MainScope.prototype, "userName", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], MainScope.prototype, "userEmail", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], MainScope.prototype, "roleLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], MainScope.prototype, "theme", void 0);
__decorate([
    observe(),
    __metadata("design:type", Scope)
], MainScope.prototype, "body", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MainScope.prototype, "dialog", void 0);
__decorate([
    observe(),
    __metadata("design:type", AlertScope)
], MainScope.prototype, "alert", void 0);
MainScope = __decorate([
    Observable
], MainScope);
export { MainScope };
//# sourceMappingURL=main.scope.js.map